import script from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFolderDetails.vue?vue&type=style&index=0&id=f8ef7d06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8ef7d06"]])

export default __exports__